enum ENetworkNoticeFallbackVariant {
    OwlSad = "owlSad"
}

export { ENetworkNoticeFallbackVariant }
